// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"4d545438e04e4e37","777":"8cf799b0d00b092c","967":"4b2b513ce4220125"}[chunkId] + ".js";
};